module.exports = ".form-group label{\r\n    color: #0000ff;    \r\n    font-size: 16px;\r\n    font-weight: normal\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/Main/register-page/register-page.component.css
// module id = ./src/app/pages/Main/register-page/register-page.component.css
// module chunks = main